import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchSingleBooking } from "shared/services";
import classNames from "classnames";
import commonstyles from "shared/utils/common.module.css";
import styles from "./Booking.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CustomLoader from "shared/components/New_Loader/Loader";
import dayjs from "dayjs";
import { RxDownload } from "react-icons/rx";
import { useTranslation } from "react-i18next";
import { useDirection } from "shared/utils/DirectionContext";
import { HiOutlineDownload } from "react-icons/hi";
import { notifyError } from "shared/components/A_New_Components/ToastNotification";
const BookingDetailsFlight = () => {
  const { t, i18n }: any = useTranslation();
  const { isRtl } = useDirection();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  console.log("🚀 ~ BookingDetailsFlight ~ data:", data);
  const { state } = useLocation();
  const type = state?.activeTab;
  const item = state?.item;

  useEffect(() => {
    fetchSingle();
  }, []);
  const fetchSingle = () => {
    setLoading(true);
    const params = {
      requestType: type.toLowerCase(),
      bookingId: item?._id,
    };

    fetchSingleBooking(params)
      .then((res: any) => {
        setData(res?.data?.booking);
      })
      .catch((err: any) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDownload = (file: string | Blob | null) => {
    if (file) {
      const url = typeof file === "string" ? file : URL.createObjectURL(file);

      window.open(url, "_blank");

      if (typeof file !== "string") {
        URL.revokeObjectURL(url);
      }
    } else {
      notifyError("File is not Available.");
    }
  };
  return (
    <div
      className={
        ["ur", "ar", "ps", "pr"].includes(i18n.language)
          ? commonstyles.pl36
          : commonstyles.pr36
      }
    >
      <p className={styles.MainHeading}>{t("bookingDetails")}</p>
      {type === "Flight" ? (
        <>
          <div className={styles.outerContainer}>
            <p className={styles.Heading}>{t("bookedBy")}</p>
            <div className={styles.flxxBetween}>
              <div className={styles.w16}>
                <p className={styles.Title}>{t("Id")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("_name")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("mobile")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("email")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("bookingDate&Time")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("action")}</p>
              </div>
            </div>
            <div className={classNames(styles.flxxBetween, styles.borders)}>
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.mrNo}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.name}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.phone}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.email}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>
                  {isRtl
                    ? dayjs(data?.requestId?.createdAt)
                        .locale("ur")
                        .format("DD MMM - hh:mm A")
                    : dayjs(data?.requestId?.createdAt).format(
                        "DD MMM - hh:mm A"
                      )}
                </p>
              </div>{" "}
              <div className={styles.w16}>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    if (data?.eTicket) {
                      const link = document.createElement("a");
                      link.href = data.eTicket;
                      link.download = "E-Ticket"; // you can set a filename here
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    } else {
                      alert(t("eTicketNotAvailable"));
                    }
                  }}
                >
                  <RxDownload size={16} color="#FF7631" />
                  <p style={{ color: "#FF7631" }} className={styles.value}>
                    {t("eTicket")}
                  </p>
                </div>
              </div>
            </div>{" "}
            <p className={classNames(styles.Heading, commonstyles.mt16)}>
              {t("flightDetails")}
            </p>
            <div className={styles.flxxBetween}>
              <div className={styles.w16}>
                <p className={styles.Title}>{t("from")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("to")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("cabinClass")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("departureDate&Time")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("travlers")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("flightType")}</p>
              </div>{" "}
            </div>
            <div className={classNames(styles.flxxBetween, styles.borders)}>
              <div className={styles.w16}>
                <div className={styles.value}>
                  {data?.requestId?.flights?.map(
                    (flight: any, index: number) => (
                      <p key={index}>{flight.from}</p>
                    )
                  )}
                </div>
              </div>{" "}
              <div className={styles.w16}>
                <div className={styles.value}>
                  {data?.requestId?.flights?.map(
                    (flight: any, index: number) => (
                      <p key={index}>{flight.to}</p>
                    )
                  )}
                </div>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.requestId?.flightClass}</p>
              </div>{" "}
              <div className={styles.w16}>
                <div className={styles.value}>
                  {data?.requestId?.flights?.map(
                    (flight: any, index: number) => (
                      <p key={index}>
                        {isRtl
                          ? dayjs(flight?.departure)
                              .locale("ur")
                              .format("DD MMM - hh:mm A")
                          : dayjs(flight?.departure).format("DD MMM - hh:mm A")}
                      </p>
                    )
                  )}
                </div>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>
                  {data?.requestId?.adult +
                    data?.requestId?.children +
                    data?.requestId?.infant}
                </p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.requestType}</p>
              </div>{" "}
            </div>
          </div>

          <div className={styles.outerContainer}>
            <p className={styles.MainTitles}>{t("passengerDetails")}</p>
            {data?.travellers?.map((v: any, index: number) => (
              <div key={index} className="passenger-card">
                <p className={styles.HHeadings}>
                  {t("passenger")} {index + 1} {t("details")}
                </p>

                <div className="Wrappers">
                  <div className="Roww">
                    <p className="Tirtle">{t("_name")}:</p>
                    <p className="Value">{v?.name || "N/A"}</p>
                  </div>

                  <div className="Roww">
                    <p className="Tirtle">{t("passportNo")}:</p>
                    <p className="Value">{v?.passportNo || "N/A"}</p>
                  </div>

                  {v?.visaFile && (
                    <div
                      className="Roww clickable"
                      onClick={() => handleDownload(v.visaFile)}
                    >
                      <HiOutlineDownload size={20} color="#ff7631" />
                      <p className="downloadtilte">{t("visaFile")}</p>
                    </div>
                  )}

                  {v?.passportFile && (
                    <div
                      className="Roww clickable"
                      onClick={() => handleDownload(v.passportFile)}
                    >
                      <HiOutlineDownload size={20} color="#ff7631" />
                      <p className="downloadtilte">{t("passportFile")}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className={styles.outerContainer}>
            <p className={styles.Heading}>{t("bookedBy")}</p>
            <div className={styles.flxxBetween}>
              <div className={styles.w16}>
                <p className={styles.Title}>{t("id")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("_name")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("mobile")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("email")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("bookingDate&Time")}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.Title}>{t("payment")}</p>
              </div>
            </div>
            <div className={classNames(styles.flxxBetween, styles.borders)}>
              <div className={styles.w16}>
                <p style={{ color: "#0E54A3" }} className={styles.value}>
                  Mr {data?.userId?.mrNo}
                </p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.name}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.phone}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>{data?.userId?.email}</p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>
                  {isRtl
                    ? dayjs(data?.requestId?.createdAt)
                        .locale("ur")
                        .format("DD MMM - hh:mm A")
                    : dayjs(data?.requestId?.createdAt).format(
                        "DD MMM - hh:mm A"
                      )}
                </p>
              </div>{" "}
              <div className={styles.w16}>
                <p className={styles.value}>
                  <span
                    style={{
                      color: data?.isPaidFull ? "green" : "#B01212",
                    }}
                  >
                    {data?.isPaidFull ? t("fullyPaid") : t("partialyPaid")}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className={styles.outerContainer}>
            <p className={styles.Heading}>{t("bookingDetails")}</p>
            <div className={styles.flxxBetween}>
              <div className={styles.w14}>
                <p className={styles.Title}>{t("orderId")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("tourName")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("yourStartDateTime")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("yourEndDateTime")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("pickup_DropOffLocation")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("noOfGuest")}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.Title}>{t("totalBookedSeats")}</p>
              </div>{" "}
            </div>
            <div className={classNames(styles.flxxBetween, styles.borders)}>
              <div className={styles.w14}>
                <p style={{ color: "#0E54A3" }} className={styles.value}>
                  {data?.bookingId}
                </p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>{data?.tourId?.packageName}</p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>
                  {isRtl
                    ? dayjs(data?.requestId?.createdAt)
                        .locale("ur")
                        .format("DMMM")
                    : dayjs(data?.requestId?.createdAt).format("DMMM")}{" "}
                  - {data?.tourId?.departTime}{" "}
                </p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>
                  {isRtl
                    ? dayjs(data?.tourId?.returnDate)
                        .locale("ur")
                        .format("DMMM")
                    : dayjs(data?.data?.tourId?.returnDate).format("DMMM")}{" "}
                  -{data?.tourId?.destinationTime}
                </p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>
                  {" "}
                  {data?.tourId?.from}
                  {data?.tourId?.to}
                </p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>
                  {data?.totalUser} {t("tourist")}
                </p>
              </div>{" "}
              <div className={styles.w14}>
                <p className={styles.value}>
                  {data?.tourId?.bookedSeats} / {data?.tourId?.limitedSeats}
                </p>
              </div>{" "}
            </div>
          </div>
        </>
      )}
      {loading && <CustomLoader />}
    </div>
  );
};

const InfoRow = ({ label, value }: { label?: any; value?: any }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <p style={{ fontSize: "14px", color: "#0D47A1" }}>
      <strong>{label}</strong>
    </p>
    <p style={{ fontSize: "14px", color: "#0D47A1" }}>{value}</p>
  </div>
);
const Section = ({
  value1,
  value2,
  title1,
  title2,
  title3,
  value3,
  show,
}: {
  value1?: any;
  value2?: any;
  title1?: any;
  title2?: any;
  title3?: any;
  value3?: any;
  show?: any;
}) => {
  return (
    <div>
      <div className={`${styles.row} ${styles.marginBottom}`}>
        <div>
          <span className={`${styles.text} ${styles.blueText}`}>{title1}</span>
          <span className={`${styles.text} ${styles.greyText}`}>{value1}</span>
        </div>
        <div>
          <span className={`${styles.text} ${styles.blueText}`}>{title2}</span>
          <span className={`${styles.text} ${styles.greyText}`}>{value2}</span>
        </div>
        {show && (
          <div>
            <span className={`${styles.text} ${styles.blueText}`}>
              {title3}
            </span>
            <span className={`${styles.text} ${styles.greyText}`}>
              {value3}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const Detail = (props: any) => {
  const {
    MainTitle,
    title1,
    value1,
    title2,
    value2,
    title3,
    value3,
    title4,
    value4,
    title5,
    value5,
    title6,
    value6,
    title7,
    value7,
    styles,
  } = props;
  return (
    <div>
      <h3 style={{ color: "#0D47A1", marginTop: "8px" }}>{MainTitle}</h3>
      <div style={{ gap: "8px", marginTop: "8px" }}>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title1}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400" }}>{value1}</p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title2}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400" }}>{value2}</p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title3}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400" }}>{value3}</p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title4}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400", fontSize: "12px" }}>
            {value4}
          </p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title5}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400", fontSize: "12px" }}>
            {value5}
          </p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title6}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400" }}>{value6}</p>
        </div>
        <div className={styles.rowVertical}>
          <p style={{ color: "#0D47A1", fontWeight: "500" }}>{title7}</p>
          <p style={{ color: "#0D47A1", fontWeight: "400" }}>{value7}</p>
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsFlight;
